export default "__VITE_ASSET__RgPE3qgq__"